import React, { useEffect, Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Divider,
  IconButton,
  Grid,
} from '@material-ui/core';
import { AppBar, Page, Amount, ScreenLoader } from 'components';
import { ru } from 'locale';
import { decisionsStore, anketsStore } from 'stores';
import { removeNthUrlSegment } from 'utils/string';
import { statusIcons } from '../DecisionScreen/components/DecisionItem/DecisionItem.mock';
import useStyles from './DecisionsScreen.styles';

const DecisionsScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { anketId } = anketsStore;
  const { decisions, fetchState } = decisionsStore;
  const parentUrl = removeNthUrlSegment(path, 1);

  useEffect(() => {
    decisionsStore.getDecisions(anketId);
  }, [anketId]);

  const handleBackClick = () => {
    history.goBack();
  };

  const handleItemSelect = id => () => {
    history.push(`${path}/${id}`);
  };

  const renderDecisions = () => {
    return (
      <List component="nav" aria-label={ru.decisions}>
        {decisions.map((decision, idx) => {
          const { status } = decision;
          const Icon = statusIcons[status];
          const isApproved = status === 'agreed';

          return (
            /* eslint-disable-next-line react/no-array-index-key */
            <Fragment key={decision.id}>
              <ListItem button onClick={handleItemSelect(decision.id)}>
                <ListItemText
                  primary={`${decision.scoringRole}: ${decision.userName}`}
                  secondary={
                    isApproved ? (
                      <>
                        <Amount
                          amount={{
                            value: decision.limit,
                            currency: { code: 'RUR', minority: 0 },
                          }}
                        />
                        {` | ${decision.term}`}
                      </>
                    ) : null
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end">
                    <Icon className={classes[status]} />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              {idx !== decisions.length - 1 && <Divider />}
            </Fragment>
          );
        })}
      </List>
    );
  };

  return (
    <Page className={classes.root}>
      <Grid container direction="column">
        <Grid item>
          <AppBar
            title={ru.decisions}
            onNavButtonClick={handleBackClick}
            backUrl={`${parentUrl}#loan-borrower`}
            typeNavIcon="link"
          />
        </Grid>
        {fetchState === 'pending' && <ScreenLoader />}
        <Grid item>{fetchState === 'fulfilled' && renderDecisions()}</Grid>
      </Grid>
    </Page>
  );
});

export default DecisionsScreen;
